function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min)) + min;
}

function animationImg(id) {
  const $setElm = $(`#${id}`), fadeSpeed = 1000, switchDelay = getRandomInt(5000, 7000);

  if ($setElm.find('li').length !== 1) {
      $setElm.each(function() {
        const targetObj = $(this);
        const findUl = targetObj.find('ul');
        const findLi = targetObj.find('li');
        const findLiFirst = targetObj.find('li:first');

        findLi.css({ display: 'block', opacity:'0', zIndex:'99' });
        findLiFirst.css({ zIndex:'100' }).stop().animate({ opacity:'1' }, fadeSpeed);

        setInterval(function() {
          findUl.find('li:first-child')
            .animate({
              opacity: '0'
            }, fadeSpeed)
            .next('li').css({ zIndex: '100' })
            .animate({
              opacity:'1'
            }, fadeSpeed)
            .end()
            .appendTo(findUl).css({ zIndex:'99' });
        }, switchDelay);
      });
  }
}
